export const isKeyActive = ({
  active,
  expiredAt,
}: {
  expiredAt: Date;
  active: boolean;
}) => active && expiredAt.getTime() > Date.now();
